import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams, ViewController} from 'ionic-angular';
import {TwitterUsers} from "../../providers/twitter-users";

/**
 * Generated class for the TwitterKeywordForm page.
 *
 * on Ionic pages and navigation.
 */
// @IonicPage()
@Component({
  selector: 'page-twitter-keyword-form',
  templateUrl: 'twitter-keyword-form.html',
})
export class TwitterKeywordForm {
  keyword = {
    id: null,
    enabled: true,
    alarmEnabled: false,
    emailEnabled: false,
    tag: '',
    keywords: '',
    twitterHashtags: '',
    twitterAuthors: [],
    twitterMentions: [],
    twitter: true,
    shared: false,
    color: '00cccc'
  }

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private viewCtrl: ViewController,
              public twitterUsers: TwitterUsers) {
  }

  colorList = [
    ['Nero', '000000'],
    ['Grigio', '808080'],
    ['Argento', 'C0C0C0'],
    ['Bianco', 'FFFFFF'],
    ['Granata', '800000'],
    ['Rosso', 'FF0000'],
    ['Verde oliva', '808000'],
    ['Giallo', 'FFFF00'],
    ['Verde', '008000'],
    ['Lime', '00FF00'],
    ['Teal', '008080'],
    ['Acqua', '00FFFF'],
    ['Blu scuro', '000080'],
    ['Blu', '0000FF'],
    ['Porpora', '800080'],
    ['Fucsia', 'FF00FF']
  ];

  ionViewDidLoad() {
    if (this.navParams.get('k') === null) {

    } else {
      this.keyword = this.navParams.get('k');
    }
    // console.log('ionViewDidLoad TwitterKeywordForm');
  }

  dismiss(data) {
    if (data === null) {
      this.viewCtrl.dismiss(null);

    } else {

      this.viewCtrl.dismiss(this.keyword);
    }
  }

  addMention(event) {
    this.keyword.twitterMentions.push({
      "id": 0,
      "name": event.name,
      "screenName": event.screenName,
      "twitterId": event.userId,
      "link": "https://twitter.com/" + event.screenName,
      "photoUrl": event.photoUrl
    });
  }

  addAuthor(event) {
    this.keyword.twitterAuthors.push({
      "id": 0,
      "name": event.name,
      "screenName": event.screenName,
      "twitterId": event.userId,
      "link": "https://twitter.com/" + event.screenName,
      "photoUrl": event.photoUrl
    });
  }

  removeMention(item) {
    // console.log(this.keyword.twitterMentions.indexOf(item));
    this.keyword.twitterMentions.splice(this.keyword.twitterMentions.indexOf(item), 1);
  }


  removeAuthor(item) {
    this.keyword.twitterAuthors.splice(this.keyword.twitterAuthors.indexOf(item), 1);
  }
}



// WEBPACK FOOTER //
// ./src/pages/twitter-keyword-form/twitter-keyword-form.ts